module.exports = __webpack_public_path__ + "static/media/sports car in a forest.f401da89.jpeg";